// TYPES
export const SET_BOARD_CLASS_LIST = 'SET_BOARD_CLASS_LIST';

// ACTIONS
export const setBoardClassList = payload => {
  return { type: SET_BOARD_CLASS_LIST, payload };
};
